var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"id":"input-group-1","label":_vm.field.label,"label-for":`input-${_vm.field.label}`}},[_c('b-form-textarea',{attrs:{"id":"textarea","placeholder":_vm.field.placeholder,"rows":"3","max-rows":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }